import axios from "axios";
import { WEB_ROUTES } from "../WebEncryption";
import { LoginWithPinRequest } from "../../Models/Request/Authentication/Login";
import {
  DeleteUserOtp,
  SendOtpRequest,
  VerifyOtpRequest,
} from "../../Models/Request/Authentication/Otp";
import {
  SignupConfirmationRequest,
  SignupOtpInitiateRequest,
} from "../../Models/Request/Authentication/Signup";
import { getBrowserFingerprint } from "../../Utils/deviceFingerprint";

export function sendOtp(sendOtpBody: SendOtpRequest) {
  return axios.post(WEB_ROUTES.sendOtp, sendOtpBody);
}

export function verifyOtp(verifyOtpBody: VerifyOtpRequest) {
  return axios.post(WEB_ROUTES.verifyOtp, verifyOtpBody);
}

export async function verifyOtpWithFingerPrint(verifyOtpBody: VerifyOtpRequest) {
  const fingerprint = await getBrowserFingerprint();

  const verifyOtpRequestBody = {
    ...verifyOtpBody,
    fingerprint,
  };
  return axios.post(WEB_ROUTES.verifyOtpWithFingerprint, verifyOtpRequestBody);
}

export function signupOtp(signupOtpBody: SignupOtpInitiateRequest) {
  return axios.post(WEB_ROUTES.signup, signupOtpBody);
}

export function signupVerification(
  verificationBody: SignupConfirmationRequest
) {
  return axios.post(WEB_ROUTES.signupVerify, verificationBody);
}

export async function signupVerificationWithFingerPrint(verificationBody: SignupConfirmationRequest) {
  const fingerprint = await getBrowserFingerprint();

  const verificationRequestBody = {
    ...verificationBody,
    fingerprint,
  };
  return axios.post(WEB_ROUTES.signupVerifyWithFingerprint, verificationRequestBody);
}

export function logInWithPin(verificationBody: LoginWithPinRequest) {
  return axios.post(WEB_ROUTES.login, verificationBody);
}

export function logInWithPinOnly(verificationBody: LoginWithPinRequest) {
  return axios.post(WEB_ROUTES.loginWithPin, verificationBody);
}

export function getAccessToken(refreshToken: string | null) {
  return axios.post(WEB_ROUTES.refreshToken, {
    REFRESH_TOKEN: refreshToken,
  });
}

export function forgotPin(newPin: string, token: string) {
  return axios.post(
    WEB_ROUTES.forgotPin,
    { newPin },
    { headers: { Authorization: `Bearer ${token}` } }
  );
}

export function signOut() {
  return axios.get(`/User/sign-out`);
}

export function deleteUserInitiate() {
  return axios.delete(`/User`);
}

export function deleteUser(body: DeleteUserOtp) {
  return axios.delete(WEB_ROUTES.deleteUserVerify, { data: body });
}

export async function verifyFingerPrint(sessionState: string, fingerprint: any) {

  const verifyFingerPrintRequest = {
    sessionState,
    fingerprint,
  };

  return axios.post("/User/Validate", verifyFingerPrintRequest);
}

export async function validatedFringerPrint() {
  const sessionState = localStorage.getItem("sessionid");

  if (!sessionState) {
    throw new Error("Session ID not found");
  }
  const fingerprint = await getBrowserFingerprint();
  const response = await verifyFingerPrint(
    sessionState,
    fingerprint
  );

  return response.data;
}